import React, { useState, useEffect } from "react";
import "./category.css";
import { Link } from "react-router-dom";

const CategoryItems = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Replace the URL with your actual Express endpoint for category items
    const fetchCategoryItems = async () => {
      const backendURL = process.env.REACT_APP_BACKEND_URL;
      try {
        const response = await fetch(`${backendURL}category/category-items`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        // Build an array of items using the fields from your Firestore document.
        const fetchedItems = [
          {
            title: data.header1,
            description: data.description1,
            img: data.image1,
            imgDark: data.image1, // Change if you have a different dark mode image
          },
          {
            title: data.header2,
            description: data.description2,
            img: data.image2,
            imgDark: data.image2,
          },
          {
            title: data.header3,
            description: data.description3,
            img: data.image3,
            imgDark: data.image3,
          },
        ];
        setItems(fetchedItems);
      } catch (error) {
        console.error("Error fetching category items:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryItems();
  }, []);

  if (loading) {
    return (
      <section className="bg-white dark:bg-gray-900">
        <div className="mx-auto max-w-screen-xl px-4 py-16">
          <p>Loading category items...</p>
        </div>
      </section>
    );
  }

  // Define an array of route paths corresponding to each item.
  const paths = ["/loose-page", "/gia-page", "/natural-page"];

  return (
    <section className="bg-white dark:bg-gray-900">
      <div className="mx-auto max-w-screen-xl px-4 py-16">
        {items.map((item, index) => (
          <div
            key={index}
            className={`flex flex-col md:flex-row items-center gap-0 py-0 px-0 mx-auto max-w-screen-xl xl:gap-0 sm:py-0 lg:px-0 ${
              index % 2 !== 0 ? "md:flex-row-reverse" : ""
            }`}
          >
            {/* Image Section */}
            <div className="flex-1 flex justify-center w-full">
              <div className="images w-full h-[400px] relative">
                <img
                  className="absolute inset-0 w-full h-full object-cover dark:hidden"
                  src={item.img}
                  alt="dashboard"
                />
                <img
                  className="absolute inset-0 w-full h-full object-cover hidden dark:block"
                  src={item.imgDark}
                  alt="dashboard"
                />
              </div>
            </div>

            {/* Text Section */}
            <div className="flex-1 text-center md:text-left textsize flex flex-col justify-center items-center">
              <h2 className="text-center mb-4 text-4xl tracking-tight dark:text-white">
                {item.title}
              </h2>
              <p className="text-center mb-0 font-light text-gray-500 md:text-lg dark:text-gray-400 px-16">
                {item.description}
              </p>
              {/* Use the current index to set the route dynamically */}
              <Link to={paths[index]}>
                <button
                  className="inline-flex items-center text-white primary-color hover:bg-yellow-700 focus:ring-2 focus:ring-yellow-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-yellow-900 mt-8"
                >
                  Shop
                  <svg
                    className="ml-2 -mr-1 w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                </button>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CategoryItems;
